var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('os-datatable',{attrs:{"title":"Questionnaires","headers":_vm.header,"create-enabled":false},on:{"rowclicked":(e) => _vm.$emit('rowclicked', e)},model:{value:(_vm.questionnaires),callback:function ($$v) {_vm.questionnaires=$$v},expression:"questionnaires"}})
}
var staticRenderFns = []

export { render, staticRenderFns }